import { render, staticRenderFns } from "./AirBnbUnitSetupForm.vue?vue&type=template&id=2a149ebc&scoped=true&"
import script from "./AirBnbUnitSetupForm.vue?vue&type=script&lang=js&"
export * from "./AirBnbUnitSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a149ebc",
  null
  
)

export default component.exports